import React, { useState } from 'react';
import classes from "./BottomNavbar.module.css";
import { BsGrid, BsFillGridFill } from "react-icons/bs";
import { PiCrownLight, PiCrownFill } from "react-icons/pi";
import { HiHome, HiOutlineHome } from "react-icons/hi";
import { MdOutlineLeaderboard, MdLeaderboard } from "react-icons/md";
import { RiAccountPinCircleLine, RiAccountPinCircleFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BottomNavbar = ({active}) => {
    const navigate = useNavigate();
    const {t}=useTranslation();
    return (
        <div className={classes.bottom_navbar_container}>
            <div className={classes.bottom_navbar}>
                <div className={classes.bottom_navbar_item} onClick={() => navigate("/home")}>
                    {active === 0 ?
                        <>
                            <HiHome className={`${classes.bottom_nav_icon} ${classes.active}`} />
                            <p className={`${classes.bottom_nav_text} ${classes.active}`}>{t("53")}</p>
                        </>
                        : (
                            <>
                                <HiOutlineHome className={`${classes.bottom_nav_icon}`} />
                                <p className={`${classes.bottom_nav_text}`}>{t("53")}</p>
                            </>
                        )
                    }

                </div>
                <div className={classes.bottom_navbar_item} onClick={() => navigate("/all-quizes")}>
                    {active === 1 ?
                        <>
                            <BsFillGridFill className={`${classes.bottom_nav_icon} ${classes.active}`} />
                            <p className={`${classes.bottom_nav_text} ${classes.active}`}>{t("54")}</p>
                        </>
                        : (
                            <>
                                <BsGrid className={`${classes.bottom_nav_icon}`} />
                                <p className={`${classes.bottom_nav_text}`}>{t("54")}</p>
                            </>
                        )
                    }
                </div>
                {/* <div className={classes.bottom_navbar_item} onClick={() => navigate("/championship")}>
                    {active === 2 ?
                        <>
                            <PiCrownFill className={`${classes.bottom_nav_icon} ${classes.active}`} />
                            <p className={`${classes.bottom_nav_text} ${classes.active}`}>Championship</p>
                        </>
                        : (
                            <>
                                <PiCrownLight className={`${classes.bottom_nav_icon}`} />
                                <p className={`${classes.bottom_nav_text}`}>Championship</p>
                            </>
                        )
                    }
                </div> */}
                <div className={classes.bottom_navbar_item} onClick={() => navigate("/leaderboard")}>
                    {active === 3 ?
                        <>
                            <MdLeaderboard className={`${classes.bottom_nav_icon} ${classes.active}`} />
                            <p className={`${classes.bottom_nav_text} ${classes.active}`}>{t("55")}</p>
                        </>
                        : (
                            <>
                                <MdOutlineLeaderboard className={`${classes.bottom_nav_icon}`} />
                                <p className={`${classes.bottom_nav_text}`}>{t("55")}</p>
                            </>
                        )
                    }
                </div>
                <div className={classes.bottom_navbar_item} onClick={() => navigate("/profile")}>
                    {active === 4 ?
                        <>
                            <RiAccountPinCircleFill className={`${classes.bottom_nav_icon} ${classes.active}`} />
                            <p className={`${classes.bottom_nav_text} ${classes.active}`}>{t("56")}</p>
                        </>
                        : (
                            <>
                                <RiAccountPinCircleLine className={`${classes.bottom_nav_icon}`} />
                                <p className={`${classes.bottom_nav_text}`}>{t("56")}</p>
                            </>
                        )
                    }
                </div>
            </div>
        </div>

    )
}

export default BottomNavbar